import { ExportInterface } from '@app/exports/models/interfaces/export.interface';

export const ALL_EXPORTS: Readonly<ExportInterface> = {
    blocked: 0,
    compression: '',
    created_at: '',
    cron: null,
    cron_timezone: null,
    cxn_id: 0,
    db_id: '',
    deduplicate_field_name: [],
    deduplicate_preserve_nulls: '0',
    delimiter: '',
    enclosure: '',
    escape: '',
    export_encoding: '',
    export_format: '',
    export_index_field: '',
    export_selector: '',
    export_triggered: false,
    export_type: null,
    file_footer: '',
    file_header: '',
    file_name: '',
    ftp_triggered: false,
    ftp_url: '',
    host: '',
    id: '0',
    include_column_names: '0',
    item_group_id: '',
    json_minify_type: '',
    last_run_duration: '',
    legacy_workers: '0',
    max_attempts: 0,
    name: 'All exports',
    next_run_time: '',
    password: '',
    paused: '0',
    paused_at: '',
    protocol: '',
    protocol_info: {},
    quoted_fields: '0',
    row_limit: '0',
    row_order: '',
    row_sort: '',
    running: '0',
    show_empty_parent_tags: '0',
    show_empty_tags: '0',
    strip_characters: '',
    tags: [],
    threshold: 0,
    time_between_attempts: 0,
    time_running: '',
    timeout: 0,
    timestamp: '',
    use_cdata: 0,
    username: '',
    worker_hostname: '',
    worker_pid: 0,
    xml_write_document_tag: '0',
    zip_inner_file_name: ''
}
